import React from "react";
import {
  Container,
  Box,
  Grid,
  Tabs,
  Tab,
  Paper,
  Skeleton,
} from "@mui/material";

const ProjectDetailViewSkeleton: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 2 }}>
      {/* Navigation Header Skeleton */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Box>
            <Skeleton variant="text" width={200} height={32} />
            <Skeleton variant="text" width={150} height={20} />
          </Box>
          <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>

      {/* Basic Project Information Skeleton */}
      <Paper sx={{ p: 2, mb: 3 }}>
        {/* Project Name */}
        <Skeleton variant="text" width="40%" height={40} sx={{ mb: 1 }} />

        {/* Description */}
        <Skeleton variant="text" width="70%" height={24} sx={{ mb: 2 }} />

        <Grid container spacing={3}>
          {/* Status */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Skeleton variant="circular" width={16} height={16} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={40} height={16} />
                <Skeleton variant="text" width={80} height={20} />
              </Box>
            </Box>
          </Grid>

          {/* Project Manager */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Skeleton variant="circular" width={16} height={16} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={90} height={16} />
                <Skeleton variant="text" width={100} height={20} />
              </Box>
            </Box>
          </Grid>

          {/* Client */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Skeleton variant="circular" width={16} height={16} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={40} height={16} />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
            </Box>
          </Grid>

          {/* Duration */}
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Skeleton variant="circular" width={16} height={16} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width={50} height={16} />
                <Skeleton variant="text" width={140} height={20} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* Tabs Section Skeleton */}
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={false}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            "& .MuiTab-root": {
              fontSize: "0.75rem",
              minHeight: "48px",
              textTransform: "none",
            },
          }}
        >
          {Array.from({ length: 7 }).map((_, index) => (
            <Tab
              key={index}
              disabled
              label={<Skeleton variant="text" width={80} height={20} />}
              icon={<Skeleton variant="circular" width={16} height={16} />}
              iconPosition="start"
            />
          ))}
        </Tabs>
      </Box>

      {/* Tab Content Skeleton */}
      <Box sx={{ minHeight: "400px", pt: 2 }}>
        <Box sx={{ mb: 2 }}>
          <Skeleton variant="text" width="30%" height={32} />
        </Box>
        
        {/* Table-like skeleton structure */}
        <Box sx={{ border: 1, borderColor: "divider", borderRadius: 1 }}>
          {/* Header */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: "divider", bgcolor: "grey.50" }}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Skeleton variant="text" width="80%" height={20} />
              </Grid>
              <Grid item xs={3}>
                <Skeleton variant="text" width="80%" height={20} />
              </Grid>
              <Grid item xs={3}>
                <Skeleton variant="text" width="80%" height={20} />
              </Grid>
              <Grid item xs={3}>
                <Skeleton variant="text" width="80%" height={20} />
              </Grid>
            </Grid>
          </Box>

          {/* Rows */}
          {Array.from({ length: 5 }).map((_, index) => (
            <Box
              key={index}
              sx={{
                p: 2,
                borderBottom: index < 4 ? 1 : 0,
                borderColor: "divider",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <Skeleton variant="text" width="90%" height={24} />
                </Grid>
                <Grid item xs={3}>
                  <Skeleton variant="text" width="70%" height={24} />
                </Grid>
                <Grid item xs={3}>
                  <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
                </Grid>
                <Grid item xs={3}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Skeleton variant="circular" width={24} height={24} />
                    <Skeleton variant="circular" width={24} height={24} />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default ProjectDetailViewSkeleton; 